import React, { useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import global from "../../global-variables";
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top"

import WOW from 'wowjs';

export default function PeopleNav(props) {
    
    useEffect(() => {

        // initiate the wow effect
        new WOW.WOW({
            live: false
        }).init();

    }, []);

    return (
        <Container className='mb-4 d-md-block d-none'>
            <div className='d-flex justify-content-center fw-bold people-nav'>
                {
                    props.peopleCategory.map((val)=>{
                        return(
                                
                            <Link to={`${global.variables.strDomainUrl}people/${val.pcategory_pagename}`} className={val.pcategory_pagename === props.qs_pcategory_pagename ? "active" : ""}>{val.pcategory_name}</Link>
                                
                        )
                    })
                }
                
            </div>
        </Container>
    )
} 